import React, { ComponentProps, forwardRef, PropsWithChildren } from "react";
import "./FixedFooter.scss";

const FixedFooter = forwardRef<
  HTMLDivElement,
  PropsWithChildren<ComponentProps<"footer">>
>(({ children, className = "", ...restProps }, ref) => {
  return (
    <footer
      className={`MobileOnly fixed-footer ${className}`}
      ref={ref}
      {...restProps}
    >
      {children}
    </footer>
  );
});

export default FixedFooter;
